/*
 * Copyright (c) 2021-2024. StockAnywhere CC
 * StockAnywhere - https://www.stockanywhere.io
 * View license agreement and terms of use at https://www.stockanywhere.io/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2024-06-30
 */

import React, { ChangeEvent, useState } from "react";
import { useQueryListContext } from "./QueryListContext";
import { Search, X } from "lucide-react";


interface ListSearch {
    search: Map<string, string>;
    setSearch: React.Dispatch<React.SetStateAction<Map<string, string>>>;
    searchClicked: () => void;
    clearClicked: () => void;
}

export const ListSearch: React.FC<ListSearch> = (props) => {

    const {ctxData, getData, setData} = useQueryListContext();
    const [activeStatusKey, setActiveStatusKey] = useState<string | null>(null);
    
    const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
        if(event.target.type === 'text') {
            props.setSearch(prevSearch => {
                const newSearch = new Map(prevSearch);
                newSearch.set(event.target.id, event.target.value.trim());
                return newSearch;
            });
        }
    }


    const columns: React.ReactElement[] = [];
    let i: number = 0;
    const thStyle: React.CSSProperties = {
        border: '1px solid #deebed',
        color: "#6c757d",
        padding: "8px",
        whiteSpace: "nowrap" as const,
        backgroundColor: "#f8f9fa",
    };

    const thControlsStyle = {
        textWrap: 'nowrap',
        backgroundColor: 'white', //lightgray
        border: '1px solid #deebed',
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        padding:'2px 0px',
        margin: '0px'

    };

    //change column names for display
    function transformString(inputString:string) {
        // Check if the input is a string
        if (typeof inputString !== 'string') {
            return inputString;
        }

        // Remove underscores and capitalize letters following each underscore
        const result = inputString
          .split('_') // Split the string by underscores
          .map((word, index) => {
            // Capitalize the first letter of each word after the first
            return index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1);
          })
          .join(' '); // Join all the words back together
      
        // Ensure the first letter is capitalized
        return result.charAt(0).toUpperCase() + result.slice(1);
    }

    //let skipCreatedUpdated = false;

    props.search.forEach((value: string, name: string) => {
        const placeholderName = transformString(name); 

        // Skip 'notifications.reference' column
        if (typeof name === "string" && name.toLowerCase() === "notifications.reference") {
            return;
        }

         // Skip 'id' column
        if (typeof name === "string" && name.toLowerCase() === "id") {
            return;
        }

       
        if (typeof name === "string" && name.toLowerCase() === "assets.url") {
            columns.push(
                <th key={i++} scope="col" style={thStyle} className="sa-search-control"></th>
            );
            return;
        }

        columns.push(
            <th key={i++} scope="col" style={thStyle} className="sa-search-control">
                <input id={name} name={name} onChange={handleOnChange} value={value} type="text" autoComplete="off" placeholder={`Search ${placeholderName}...`} className="form-control form-control-md" />
            </th>
        );
    });


    return(
        <>
            <thead className="sa-list-search">
                <tr id="searchBar" >          
                    {columns}                   
                    <th style={thStyle}>
                            <div className="d-flex justify-content-end gap-1 w-100">
                            <button
                                type="button"
                                className="btn btn-outline-danger btn-md d-flex justify-content-center align-items-center"
                                onClick={props.searchClicked}
                            >
                            <Search style={{ width: '21px', height: '21px' }} strokeWidth={2} />
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn-md d-flex justify-content-center align-items-center"
                                onClick={props.clearClicked}
                            >
                            <X style={{ width: '21px', height: '21px' }} strokeWidth={2} />
                            </button>
                        </div>
                    </th>
                </tr>
            </thead>
        </>
    );
}

